import { Features } from './constants';

export default {
  [Features.FULLSCREEN]: true,
  [Features.AUTO_ROTATE]: true,
  [Features.VR_MODE]: true,
  [Features.GYROSCOPE]: true,
  [Features.APARTMENT_RATING]: true,
  [Features.CAPTURE_SCREENSHOT]: false,
  [Features.SOCIAL_MEDIA_SHARE]: false,
};
